(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["comparar-tamanhos"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('.cmp').forEach(function (root) {
    if (root.dataset.cmpReady) return; root.dataset.cmpReady = '1';
    var openBtn = root.querySelector('[data-cmp-open]');
    var modal   = root.querySelector('[data-cmp-modal]');
    if (!openBtn || !modal) return;
    function open()  { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { modal.hidden = true;  document.body.style.overflow = ''; }
    openBtn.addEventListener('click', open);
    modal.querySelectorAll('[data-cmp-close]').forEach(function (x) { x.addEventListener('click', close); });
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["duracao-becquer"] && !Shopify.designMode) return;
  try {
    if (typeof document !== 'undefined') {
    document.querySelectorAll('.bqd').forEach(function (root) {
      if (root.dataset.bqdReady) return;
      root.dataset.bqdReady = '1';
      var openBtn = root.querySelector('[data-bqd-open]');
      var modal = root.querySelector('[data-bqd-modal]');
      if (!openBtn || !modal) return;
      function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      function close() { modal.hidden = true; document.body.style.overflow = ''; }
      openBtn.addEventListener('click', open);
      root.querySelectorAll('[data-bqd-close]').forEach(function (x) { x.addEventListener('click', close); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["kit-builder-becquer"] && !Shopify.designMode) return;
  try {
    (function(){
    document.querySelectorAll('[data-bqk]').forEach(function(root){
      if(root.dataset.bqkReady) return; root.dataset.bqkReady='1';
      var DEBUG = root.getAttribute('data-debug')==='true';
      function log(){ if(DEBUG){ var a=['[KitBuilder]'].concat([].slice.call(arguments)); console.log.apply(console,a); } }

      var dataEl = root.querySelector('[data-bqk-data]');
      var DATA;
      try{ DATA = JSON.parse(dataEl.textContent); }
      catch(e){ console.error('[KitBuilder] JSON inválido:', e, dataEl && dataEl.textContent); return; }
      var MAIN=DATA.main, COMP=DATA.comp||[];
      log('Dados:', DATA);
      log('Imagem principal:', MAIN.img);
      if(!MAIN||!MAIN.variants||!MAIN.variants.length){ console.error('[KitBuilder] produto sem variantes'); return; }

      var u2=parseInt(root.getAttribute('data-units2'),10)||2;
      var u3=parseInt(root.getAttribute('data-units3'),10)||3;
      var badge=root.getAttribute('data-badge')||'';

      var OPTS=[{id:'u1',title:'1 unidade',units:1,badge:''}];
      if(u2>1) OPTS.push({id:'k'+u2,title:'Kit '+u2,units:u2,badge:''});
      if(u3>1 && u3!==u2) OPTS.push({id:'k'+u3,title:'Kit '+u3,units:u3,badge:badge});

      function money(c){ return 'R$ '+(c/100).toLocaleString('pt-BR',{minimumFractionDigits:2}); }
      function firstAvail(vs){ for(var i=0;i<vs.length;i++) if(vs[i].available) return i; return 0; }

      var sel=OPTS[0].id, picker=null, adding=false, slots={};
      OPTS.forEach(function(o){
        slots[o.id]=[];
        for(var i=0;i<o.units;i++){
          if(i===0) slots[o.id].push({type:'main',v:firstAvail(MAIN.variants)});
          else slots[o.id].push({type:'empty'});
        }
      });

      // Kit ativo → esconde o form nativo de compra do tema
      var nativeSel=root.getAttribute('data-native');
      if(nativeSel){ try{ document.querySelectorAll(nativeSel).forEach(function(el){ el.style.display='none'; }); log('Form nativo escondido:', nativeSel); }catch(e){ log('erro ao esconder nativo', e); } }

      var optsEl=root.querySelector('[data-bqk-opts]');
      var totEl=root.querySelector('[data-bqk-total]');
      var tvEl=root.querySelector('[data-bqk-tv]');
      var cta=root.querySelector('[data-bqk-cta]');

      function variantsOf(s){ return s.type==='main'?MAIN.variants:COMP[s.comp].variants; }
      function slotPrice(s){ if(s.type==='empty')return 0; return variantsOf(s)[s.v].price; }
      function optTotal(o){ return slots[o.id].reduce(function(a,s){return a+slotPrice(s);},0); }
      function optFilled(o){ return slots[o.id].every(function(s){return s.type!=='empty';}); }
      function imgBox(label,img){ return img?('<span class="bqk-img"><img src="'+img+'" alt=""></span>'):('<span class="bqk-img"><span>'+label+'</span></span>'); }

      function sizesHTML(oid,i,s){
        var vs=variantsOf(s);
        if(vs.length<=1) return '<span class="bqk-sizes"><span class="bqk-sz on">'+money(vs[0].price)+'</span></span>';
        var h='<span class="bqk-sizes">';
        vs.forEach(function(v,vi){ h+='<span class="bqk-sz'+(s.v===vi?' on':'')+(v.available?'':' off')+'" data-sz="'+oid+'|'+i+'|'+vi+'">'+v.title+'</span>'; });
        return h+'</span>';
      }

      function render(){
        optsEl.innerHTML='';
        OPTS.forEach(function(o){
          var active=sel===o.id;
          var card=document.createElement('div');
          card.className='bqk-opt'+(active?' active':'');
          card.onclick=function(e){ if(e.target.closest('.bqk-panel'))return; sel=o.id; picker=null; render(); };
          if(o.badge) card.innerHTML+='<div class="bqk-badge">'+o.badge+'</div>';
          var head=document.createElement('div'); head.className='bqk-head';
          head.innerHTML='<div class="bqk-radio"><i></i></div><div class="bqk-tt">'+o.title+'</div><div class="bqk-op">'+money(optTotal(o)||MAIN.variants[0].price*o.units)+'</div>';
          card.appendChild(head);
          if(active){
            var p=document.createElement('div'); p.className='bqk-panel';
            p.innerHTML='<div class="bqk-pl">'+(o.units>1?'Monte seu kit':'Escolha o tamanho')+'</div>';
            slots[o.id].forEach(function(s,i){ p.appendChild(buildSlot(o,s,i)); });
            card.appendChild(p);
          }
          optsEl.appendChild(card);
        });
        bind(); updateCTA();
      }

      function buildSlot(o,s,i){
        var w=document.createElement('div'); w.className='bqk-slot';
        w.innerHTML='<span class="bqk-n">#'+(i+1)+'</span>';
        var card=document.createElement('div');
        if(s.type==='empty'){
          card.className='bqk-card empty';
          card.innerHTML='<span class="bqk-plus">+</span><span class="bqk-addtxt">Adicionar complementar</span>';
          card.onclick=function(e){ e.stopPropagation(); picker=(picker&&picker.opt===o.id&&picker.slot===i)?null:{opt:o.id,slot:i}; render(); };
          w.appendChild(card);
          if(picker&&picker.opt===o.id&&picker.slot===i) card.appendChild(buildPicker(o,i));
          return w;
        }
        card.className='bqk-card';
        var nm=s.type==='main'?MAIN.title:COMP[s.comp].title;
        var img=s.type==='main'?MAIN.img:COMP[s.comp].img;
        card.innerHTML=imgBox(nm,img)+'<div class="bqk-nm">'+nm+'</div>'+sizesHTML(o.id,i,s)+(s.type==='comp'?'<span class="bqk-rm" data-rm="'+o.id+'|'+i+'">Trocar</span>':'');
        w.appendChild(card);
        return w;
      }

      function buildPicker(o,i){
        var pk=document.createElement('div'); pk.className='bqk-picker';
        pk.onclick=function(e){e.stopPropagation();};
        if(!COMP.length){ pk.innerHTML='<div class="bqk-ph">Sem complementares cadastrados</div>'; return pk; }
        var h='<div class="bqk-ph">Complementares deste produto</div>';
        COMP.forEach(function(c,ci){
          var hasStock=c.variants.some(function(v){return v.available;});
          if(hasStock){
            h+='<div class="bqk-pick" data-pick="'+o.id+'|'+i+'|'+ci+'">'+imgBox(c.title,c.img)+'<span class="pn">'+c.title+'</span><span class="pp">'+money(c.variants[0].price)+'</span></div>';
          } else {
            h+='<div class="bqk-pick bqk-pick--out">'+imgBox(c.title,c.img)+'<span class="pn">'+c.title+'</span><span class="pp">Esgotado</span></div>';
          }
        });
        pk.innerHTML=h; return pk;
      }

      function bind(){
        optsEl.querySelectorAll('[data-sz]').forEach(function(el){ el.onclick=function(e){ e.stopPropagation(); var p=el.getAttribute('data-sz').split('|'); slots[p[0]][+p[1]].v=+p[2]; render(); }; });
        optsEl.querySelectorAll('[data-pick]').forEach(function(el){ el.onclick=function(e){ e.stopPropagation(); var p=el.getAttribute('data-pick').split('|'); slots[p[0]][+p[1]]={type:'comp',comp:+p[2],v:firstAvail(COMP[+p[2]].variants)}; picker=null; render(); }; });
        optsEl.querySelectorAll('[data-rm]').forEach(function(el){ el.onclick=function(e){ e.stopPropagation(); var p=el.getAttribute('data-rm').split('|'); slots[p[0]][+p[1]]={type:'empty'}; render(); }; });
      }

      function curOpt(){ for(var i=0;i<OPTS.length;i++) if(OPTS[i].id===sel) return OPTS[i]; }
      function updateCTA(){
        var o=curOpt(); totEl.hidden=false; tvEl.textContent=money(optTotal(o));
        cta.classList.remove('ok');
        if(optFilled(o)){
          cta.disabled=false;
          cta.textContent=o.units===1?'Adicionar à bag':'Montar kit · Adicionar '+o.units;
          cta.onclick=addKit;
        } else {
          var falta=slots[o.id].filter(function(s){return s.type==='empty';}).length;
          cta.disabled=true; cta.onclick=null;
          cta.textContent='Faltam '+falta+' complementar'+(falta>1?'es':'');
        }
      }

      function addKit(){
        if(adding) return; adding=true;
        var o=curOpt();
        cta.disabled=true; cta.textContent='Adicionando...';
        var items=slots[o.id].map(function(s){ return { id: variantsOf(s)[s.v].id, quantity:1 }; });
        log('POST /cart/add.js', items);
        fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:items}) })
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok,body:j}; }); })
        .then(function(res){
          log('Resposta:', res);
          if(!res.ok){ adding=false; cta.disabled=false; updateCTA(); alert((res.body && res.body.description) || 'Não foi possível adicionar. (Teste fora do editor de tema.)'); return; }
          cta.classList.add('ok'); cta.textContent='✓ Adicionado';
          try{
            document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
            document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true}));
            var drawer=document.querySelector('cart-drawer-component,cart-drawer');
            if(drawer && typeof drawer.open==='function'){ try{ drawer.open(); return; }catch(e){} }
          }catch(e){}
          setTimeout(function(){ window.location.href='/cart'; },600);
        })
        .catch(function(err){ adding=false; cta.disabled=false; updateCTA(); console.error('[KitBuilder] erro:', err); alert('Erro ao adicionar ao carrinho.'); });
      }

      document.addEventListener('click',function(){ if(picker){ picker=null; render(); } });
      render();
      log('Pronto. Opções:', OPTS);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["notas-becquer"] && !Shopify.designMode) return;
  try {
    if (typeof document !== 'undefined') {
    document.querySelectorAll('.bqn').forEach(function (root) {
      if (root.dataset.bqnReady) return;
      root.dataset.bqnReady = '1';
      var openBtn = root.querySelector('[data-bqn-open]');
      var modal = root.querySelector('[data-bqn-modal]');
      if (!openBtn || !modal) return;
      function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      function close() { modal.hidden = true; document.body.style.overflow = ''; }
      openBtn.addEventListener('click', open);
      root.querySelectorAll('[data-bqn-close]').forEach(function (x) { x.addEventListener('click', close); });
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["parcelamento-becquer"] && !Shopify.designMode) return;
  try {
    if (typeof document !== 'undefined') {
    // O Horizon dispara 'variant:update', com a variante em detail.resource e o
    // produto em detail.data.productId. O bloco escutava 'variant:change' e exigia
    // detail.product — evento que ninguem emite e chave que nao existe. Resultado:
    // o handler saia antes de recalcular e a parcela seguia mostrando o preco da
    // variante anterior. 'variant:change' fica na lista por seguranca.
    ['variant:update', 'variant:change'].forEach(function (nome) {
    document.addEventListener(nome, function (event) {
      document.querySelectorAll('[data-installment-block]').forEach(function (block) {
        var productId = block.dataset.productId;
        var blockId = block.dataset.blockId;
        var cfgEl = document.querySelector('script[data-installment-config="' + blockId + '"]');
        if (!cfgEl || !event.detail) return;

        var variante = event.detail.resource || event.detail.variant;
        if (!variante || typeof variante.price !== 'number') return;

        // So compara quando os dois lados existem; sem isso um payload diferente
        // voltaria a bloquear tudo em silencio.
        var doEvento = (event.detail.data && event.detail.data.productId) ||
                       (event.detail.product && event.detail.product.id);
        if (productId && doEvento && String(productId) !== String(doEvento)) return;

        var config = JSON.parse(cfgEl.textContent);
        var price = variante.price;
        var content = block.querySelector('.installment-content');
        if (!content) return;

        var count = 0, value = 0, show = false;
        if (price >= config.min6x) { count = 6; value = price / 6; show = true; }
        else if (price >= config.min3x) { count = 3; value = price / 3; show = true; }

        if (!show) { content.innerHTML = ''; block.style.display = 'none'; return; }

        var formatted = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value / 100);
        var c = '<span class="bqi-accent">' + count + 'x</span>';
        var v = '<span class="bqi-accent">' + formatted + '</span>';
        var html;
        switch (config.textFormat) {
          case 'format_2': html = c + ' de ' + v + ' sem juros'; break;
          case 'format_3': html = 'Parcele em até ' + c + ' sem juros'; break;
          default: html = 'Em até ' + c + ' sem juros de ' + v;
        }
        content.innerHTML = html;
        block.style.display = 'block';
      });
    });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["parcelamento"] && !Shopify.designMode) return;
  try {
    // Atualiza o parcelamento quando a variante muda
  if (typeof document !== 'undefined') {
    document.addEventListener('variant:change', function(event) {
      const installmentBlocks = document.querySelectorAll('[data-installment-block]');
      
      installmentBlocks.forEach(block => {
        const productId = block.dataset.productId;
        const blockId = block.dataset.blockId;
        const configScript = document.querySelector(`script[data-installment-config="${blockId}"]`);
        
        if (!configScript || !event.detail || !event.detail.product || productId != event.detail.product.id) return;
        
        const config = JSON.parse(configScript.textContent);
        const price = event.detail.variant ? event.detail.variant.price : 0;
        const content = block.querySelector('.installment-content');
        
        if (!content) return;
        
        let installmentCount = 0;
        let installmentValue = 0;
        let showInstallment = false;
        
        if (price >= config.min6x) {
          installmentCount = 6;
          installmentValue = price / 6;
          showInstallment = true;
        } else if (price >= config.min3x) {
          installmentCount = 3;
          installmentValue = price / 3;
          showInstallment = true;
        }
        
        if (showInstallment) {
          const formattedValue = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(installmentValue / 100);
          
          let html = '';
          
          if (config.showIcon) {
            html += '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" style="display: inline-block; margin-right: 4px; vertical-align: middle;"><path d="M2 4h12M2 8h12M2 12h12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
          }
          
          if (config.textFormat === 'custom' && config.customText) {
            let text = config.customText
              .replace(/\[count\]/g, installmentCount)
              .replace(/\[value\]/g, formattedValue);
            html += text;
          } else {
            switch(config.textFormat) {
              case 'format_2':
                html += `${installmentCount}x de ${formattedValue} sem juros`;
                break;
              case 'format_3':
                html += `Parcele em até ${installmentCount}x sem juros`;
                break;
              case 'format_1':
              default:
                html += `Em até <strong>${installmentCount}x</strong> sem juros de ${formattedValue}`;
            }
          }
          
          content.innerHTML = html;
          block.style.display = 'block';
        } else {
          content.innerHTML = '';
          block.style.display = 'none';
        }
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["personalizacao-becquer"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.dataset.bqpReady) return;
    root.dataset.bqpReady = '1';

    var propName = root.getAttribute('data-prop') || 'Personalização';
    var maxIni = parseInt(root.getAttribute('data-max-ini'), 10) || 3;
    var maxNome = parseInt(root.getAttribute('data-max-nome'), 10) || 20;

    var field = root.querySelector('[data-bqp-field]');
    var input = root.querySelector('[data-bqp-input]');
    var count = root.querySelector('[data-bqp-count]');
    var hand = root.querySelector('[data-bqp-hand]');
    var ph = root.querySelector('[data-bqp-ph]');
    var square = root.querySelector('.bqp-square');
    var optBtns = root.querySelectorAll('[data-bqp-toggle]');
    var typeBtns = root.querySelectorAll('[data-bqp-type]');

    var state = { on: false, type: 'nome', raw: '' };

    function maxFor() { return state.type === 'iniciais' ? maxIni : maxNome; }

    function transform(type, raw) {
      if (!raw) return '';
      if (type === 'iniciais') return raw.toUpperCase();
      return raw.toLowerCase().replace(/(^|\s)(\p{L})/gu, function (m, a, b) { return a + b.toUpperCase(); });
    }

    function cartForm() { return document.querySelector('form[action*="/cart/add"]'); }

    function syncProp(val) {
      var form = cartForm();
      if (!form) return;
      var inp = form.querySelector('input[data-bqp-prop="' + root.id + '"]');
      if (val) {
        if (!inp) {
          inp = document.createElement('input');
          inp.type = 'hidden';
          inp.setAttribute('data-bqp-prop', root.id);
          inp.name = 'properties[' + propName + ']';
          form.appendChild(inp);
        }
        inp.value = val;
      } else if (inp) {
        inp.remove();
      }
    }

    function render() {
      var display = transform(state.type, state.raw);
      if (display) {
        hand.textContent = display;
        hand.hidden = false;
        ph.hidden = true;
      } else {
        hand.hidden = true;
        ph.hidden = false;
      }
      if (count) count.textContent = state.raw.length + '/' + maxFor();
      syncProp(state.on ? display : '');
    }

    optBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.on = btn.getAttribute('data-bqp-toggle') === 'yes';
        optBtns.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
        field.hidden = !state.on;
        if (state.on && input) setTimeout(function () { input.focus(); }, 30);
        render();
      });
    });

    typeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.type = btn.getAttribute('data-bqp-type');
        state.raw = '';
        if (input) {
          input.value = '';
          var ph2 = btn.getAttribute('data-ph');
          if (ph2) input.placeholder = ph2;
        }
        typeBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        render();
      });
    });

    if (input) {
      input.addEventListener('input', function () {
        var v = input.value.replace(/[^\p{L}\s]/gu, '');
        if (state.type === 'iniciais') v = v.replace(/\s/g, '');
        v = v.slice(0, maxFor());
        state.raw = v;
        input.value = v;
        render();
      });
    }

    var vid = root.querySelector('[data-bqp-vid]');
    if (vid) {
      var videoEl = vid.querySelector('video');
      root.querySelectorAll('[data-bqp-video-open]').forEach(function (b) {
        b.addEventListener('click', function () { vid.hidden = false; document.body.style.overflow = 'hidden'; if (videoEl) { try { videoEl.play(); } catch (e) {} } });
      });
      function closeVid() { vid.hidden = true; document.body.style.overflow = ''; if (videoEl) videoEl.pause(); }
      root.querySelectorAll('[data-bqp-video-close]').forEach(function (b) { b.addEventListener('click', closeVid); });
      vid.addEventListener('click', function (e) { if (e.target === vid) closeVid(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVid(); });
    }

    render();
  }
  document.querySelectorAll('[data-bqp]').forEach(init);
  document.addEventListener('shopify:block:select', function (e) { var el = e.target.querySelector ? e.target.querySelector('[data-bqp]') : null; if (el) init(el); });
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-bqp]').forEach(init); });
})();
  } catch(e) { console.error(e); }
})();

})();
